module.exports = __webpack_public_path__ + "8e41fe3506ae11cfd68f4b1358f8a5bf.jpg";